module.exports = __webpack_public_path__ + "img/3-5-modelo.88adf59c.jpg";